import React from "react";
import styled from "styled-components";
import { Doughnut } from "react-chartjs-2";

const Container = styled.div`
  width: ${props => props.width};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const Overlay = styled.div`
  position: absolute;
  font-size: ${props => props.overlaySize};
  color: ${props => props.color};
`;

const innerCircleOptions = {
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  cutoutPercentage: 70,
  circumference: 2 * Math.PI,
  animation: {
    duration: 0
  },
  elements: {
    arc: {
      borderWidth: 0
    }
  }
};
const DoughnutGraph = ({ width, color, overlaySize, score }) => {
  const [data, setData] = React.useState([]);

  const datasetKeyProvider = () => {
    return Math.random();
  };

  React.useEffect(() => {
    const indicator1 = score * 0.3;
    const indicator2 = score * 0.25;
    const indicator3 = score * 0.2;
    const indicator4 = score * 0.2;
    const indicator5 = score * 0.05;
    const total =
      100 - indicator1 - indicator2 - indicator3 - indicator4 - indicator5;

    const dummy = {
      datasets: [
        {
          data: [
            indicator1,
            indicator2,
            indicator3,
            indicator4,
            indicator5,
            total
          ],
          backgroundColor: [
            "#00AEEF",
            "#FBB03F",
            "#764B9E",
            "#5CC19C",
            "#E03180",
            "#4A4A4A"
          ],
          borderWidth: []
        }
      ]
    };
    setData(dummy);
  }, [score]);

  return (
    <Container width={width}>
      <Doughnut
        label={datasetKeyProvider()}
        data={data}
        options={innerCircleOptions}
      />
      <Overlay color={color} overlaySize={overlaySize}>
        {score}
      </Overlay>
    </Container>
  );
};

export default DoughnutGraph;
